import { BackgroundImage } from './BackgroundImage';
import { Content } from './Content';

const About = () => {
  return (
    <section id="o-meni" className="relative py-32 overflow-hidden">
      <BackgroundImage />
      <div className="container-custom">
        <Content />
      </div>
    </section>
  );
};

export default About;